import I18n from "../../I18n";
import { datetime } from "../../utils";
import { Buffer } from "buffer";
import { prepareSeverityByStatus } from "../../utils/auditNoteSeverityConverter";

export const mapDetails = (json) => {
    const { AuditNote, AuditStatus, CreatedBy, ModifiedBy } = json;
    return [
        [{ labels: ["AuditNote"], value: AuditNote, type: "string" }],
        [{ labels: ["AuditStatus"], value: AuditStatus, type: "string" }],
        [{ labels: ["CreatedBy"], value: CreatedBy, type: "string" }],
        [{ labels: ["ModifiedBy"], value: ModifiedBy, type: "string" }],
    ];
};

const mapCard = (json) => {
    const {
        AuditNote,
        AuditStatus,
        CreatedBy,
        ModifiedBy,
        Origin,
        CreatedAt,
        UpdatedAt,
        EntityName,
        RowID,
        Source,
        modulePrefix,
    } = json;
    const idToUse = JSON.stringify({
        [`CDM_${EntityName}.ID`]: RowID,
        [`CDM_${EntityName}.FKID`]: RowID,
    });
    const replacedAuditStatus = AuditStatus.replaceAll(" ", "-");
    const { family, severity } = prepareSeverityByStatus((replacedAuditStatus || "").toLowerCase());
    return [
        [
            {
                value: AuditNote,
            },
        ],
        [
            {
                value: {
                    severity: severity,
                    label: I18n.translate`${replacedAuditStatus}`,
                    family: family || "text",
                    color: "main",
                },
                type: "status",
            },
        ],
        [{ value: I18n.translate`${Origin}` }],
        [{ value: CreatedBy }],
        [{ value: ModifiedBy }],
        [{ value: datetime(CreatedAt) }],
        [{ value: datetime(UpdatedAt) }],
        [
            Source && Origin === "Finding"
                ? {
                      labels: ["Entity"],
                      value: EntityName,
                      type: "string",
                      align: "center",
                  }
                : {
                      labels: ["Entity"],
                      value: {
                          id: Origin === "Rule" ? Source : Buffer.from(idToUse).toString("base64"),
                          name: EntityName,
                          __typename: `${EntityName}`,
                          customParam: modulePrefix && { modulePrefix: `${modulePrefix}` },
                      },
                      type: "object",
                      align: "center",
                  },
        ],
    ];
};

const mapper = (json, card, details) => {
    return {
        id: json.id,
        ...json,
        name: json.id,
        shortName: json.id,
        card: card ? mapCard(json) : [],
        details: details ? mapDetails(json) : [],
    };
};

const header = [
    {
        label: ["Audit Note"],
        align: "left",
        sortable: true,
        columnName: "AuditNote",
        type: "string",
    },
    {
        label: ["Audit Status"],
        align: "center",
        sortable: true,
        columnName: "AuditStatus",
        type: "status",
    },
    { label: ["Origin"], align: "center", sortable: true, columnName: "Origin", type: "string" },
    { label: ["Created By"], align: "left", type: "string" },
    { label: ["Modified By"], align: "left", type: "string" },
    { label: ["Created At"], align: "center", type: "string" },
    { label: ["Updated At"], align: "center", type: "string" },
    { label: ["Entity"], align: "center", type: "object" },
];

const auditnoteMapper = {
    map: mapper,
    header,
};

export default auditnoteMapper;
